export enum EUiStates {
  SUCCESS = "success",
  DANGER = "danger",
  WARNING = "warning",
}
